module.exports = __webpack_public_path__ + "components/country-flag/static/tm-d658ae6d9566710f23ff9ca024b6c782.svg";